import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import "react-datepicker/dist/react-datepicker.css";
import './assets/styles/App.css';
// import { DataProvider } from './context/DataContext';
import { AuthContext, AuthProvider } from './context/AuthContext';
import { useContext, useEffect } from 'react';
// import Graphs from './components/dashboard/Graphs';
import FlowDashboard from './components/dashboard/FlowDashboard';
import MapViewComponent from './components/specific/MapViewComponent';
import LoginPage from './pages/Login';
import ForgotPasswordPage from './pages/ForgotPassword';
import ResetPasswordPage from './pages/ResetPassword';
import RegisterPage from './pages/Register';
import ChangePasswordPage from './pages/ChangePassword';
import AdminPanelPage from './pages/AdminPanel';
import NotFoundPage from './pages/NotFound';
import ProtectedRoute from './routes/ProtectedRoute';
import AdminRoute from './routes/AdminRoute';
import NavbarComponent from './components/layout/Navbar';
import ESGPortfolioDashboard from './pages/ESGPortfolioDashboard';
import CarbonPortfolioDashboard from './pages/CarbonPortfolioDashboard';
import FarmTwinESGDashboard from './pages/NeilHarleyESG';
import Portfolio from './pages/RiversafePortfolio';
import FarmDetail from './pages/RiversafeFarmDetail';
import CowCollarDashboard from './pages/CowCollarDashboard';
import FarmTwinDailyDashboard from './pages/FarmTwinDailyDashboard';
import AbpSainsburysDashboard from './pages/AbpSainsburysDashboard';

/**
 * Main App component that wraps the entire application in context providers
 * and sets up routing with public and protected routes.
 */
function App() {
  return (
    <AuthProvider>  {/* AuthProvider wraps the app to manage authentication state */}
      {/*<DataProvider> /!* DataProvider wraps the app to manage data state *!/*/}
        <Router> {/* Router component to handle routing and navigation */}
          <AppContent /> {/* Main app content containing routes and navigation */}
        </Router>
      {/*</DataProvider>*/}
    </AuthProvider>
  );
}

/**
 * AppContent component containing the routes and conditional rendering for 
 * the Navbar based on the current route.
 */
function AppContent() {
  const location = useLocation(); // Get the current route location
  const { token } = useContext(AuthContext); // Get the current auth token to avoid showing app navigation when logged out

  // Hide Navbar on auth routes and whenever the user is not authenticated
  const hideNavbar = !token || ['/login', '/forgot-password', '/reset-password', '/register'].includes(location.pathname);

  const isMapRoute = location.pathname === '/';

  useEffect(() => {
    document.body.classList.toggle('map-page-lock', isMapRoute);

    return () => {
      document.body.classList.remove('map-page-lock');
    };
  }, [isMapRoute]);

  return (
    <div>
      {/* Conditionally render Navbar only if the current route is not an auth route and the user is logged in */}
      {!hideNavbar && <NavbarComponent />}

      <div className="app-container">
        <Routes> {/* Set up the routes for the app */}
          {/* Public Route for Login */}
          <Route path="/login" element={<LoginPage />} />

          {/* Public Route for Forgot Password */}
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />

          {/* Public Route for Reset Password */}
          <Route path="/reset-password" element={<ResetPasswordPage />} />

          {/* Public Route for Invite Registration */}
          <Route path="/register" element={<RegisterPage />} />
          
          {/* Protected Routes */}
          <Route path="/" element={
            <ProtectedRoute> {/* Protect the MapView route */}
              <MapViewComponent /> {/* MapView component (only accessible to authenticated users) */}
            </ProtectedRoute>
          } />

          <Route path="/change-password" element={
            <ProtectedRoute> {/* Protect the Change Password route */}
              <ChangePasswordPage /> {/* Change Password page (only accessible to authenticated users) */}
            </ProtectedRoute>
          } />

          <Route path="/admin" element={
            <AdminRoute> {/* Protect the Admin Panel route for admin users */}
              <AdminPanelPage /> {/* Admin Panel page (only accessible to admin users) */}
            </AdminRoute>
          } />
          
          {/*<Route path="/graphview" element={*/}
          {/*  <ProtectedRoute> /!* Protect the Graphs route *!/*/}
          {/*    <Graphs /> /!* Graphs component (only accessible to authenticated users) *!/*/}
          {/*  </ProtectedRoute>*/}
          {/*} />*/}

          {/*{allowedUsers.includes(ls_username) && (*/}
          <Route path="/flowdashboard" element={
            <AdminRoute> {/* Protect the FlowDashboard route for admin users */}
              <FlowDashboard /> {/* FlowDashboard component (only accessible to admin users) */}
            </AdminRoute>
          } />
          {/*)}*/}

          <Route path="/esgportfoliodashboard" element={
            <AdminRoute>
              <ESGPortfolioDashboard />
            </AdminRoute>
          } />
          
          <Route path="/carbonportfoliodashboard" element={
            <AdminRoute>
              <CarbonPortfolioDashboard />
            </AdminRoute>
          } />

          <Route path="/neilharleyesg" element={
            <AdminRoute>
              <FarmTwinESGDashboard />
            </AdminRoute>
          } />

          <Route path="/riversafeportfolio" element={
            <AdminRoute>
              <Portfolio />
            </AdminRoute>
          } />

          <Route path="/riversafeportfolio/farm/:code" element={
            <AdminRoute>
              <FarmDetail />
            </AdminRoute>
          } />

          <Route path="/cowcollardashboard" element={
            <AdminRoute>
              <CowCollarDashboard />
            </AdminRoute>
          } />

          <Route path="/farmtwindailydashboard" element={
            <AdminRoute>
              <FarmTwinDailyDashboard />
            </AdminRoute>
          } />

          <Route path="/abpsainsburysdashboard" element={
            <AdminRoute>
              <AbpSainsburysDashboard />
            </AdminRoute>
          } />

          {/* Catch-all route for pages that do not exist */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
